"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.versionCompare = exports.default = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.string.split.js");

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _window, _window$navigator, _context;

/**
 * @file env.ts 常用环境变量
 * @author wangning25 <wangning25@baidu.com> on 2021/12/05.
 */
var ua = ((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent) || '';
var env = {
  // 是否是直播中台H5容器
  is: (0, _includes.default)(_context = ua.toLowerCase()).call(_context, 'medialiveversion'),
  // 系统平台相关
  isIOS: /iphone|ipad|ipod|ios/i.test(ua),
  isAndroid: /android/i.test(ua),
  // 直播SDK版本号
  sdkVersion: ua.replace(/.*MediaLiveVersion\/([\d\.]+).*/i, '$1'),
  // 浏览模式 ((b|c)_(in|out)_(full|half))
  viewMode: ua.replace(/.*MediaLiveViewMode\/(\w+).*/i, '$1')
};
/**
 * 比较两个参数版本大小
 *
 * @param {string} version1 v1
 * @param {string} version2 v2
 * @return {number} 1 v1 > v2 ; -1 v1 < v2 ; 0 v1 = v2
 */

var versionCompare = function versionCompare(version1, version2) {
  var _context2, _context3;

  if (version1 === version2) {
    return 0;
  }

  function toNumber(item) {
    if (!(+item >= 0)) {
      throw new Error('传递了非法版本号:: ' + item);
    }

    return +item;
  }

  var versionArray1 = (0, _map.default)(_context2 = ('' + version1).split('.')).call(_context2, toNumber);
  var versionArray2 = (0, _map.default)(_context3 = ('' + version2).split('.')).call(_context3, toNumber);
  var i = 0;
  var len = Math.max(versionArray1.length, versionArray2.length);

  for (; i < len; i++) {
    if (versionArray1[i] > versionArray2[i] || versionArray1[i] && !versionArray2[i] && versionArray1[i] > 0) {
      return 1;
    } else if (versionArray1[i] < versionArray2[i] || versionArray2[i] && !versionArray1[i] && versionArray2[i] > 0) {
      return -1;
    }
  }

  return 0;
};

exports.versionCompare = versionCompare;
var _default = env;
exports.default = _default;